import { type FC, type ReactNode, useEffect, useRef, useState } from "react";

import { css, cx } from "@emotion/css";
import { Tooltip } from "@snapchat/snap-design-system";

import { truncate } from "../styles";
import { isTruncated } from "../utils/browser";

const tooltipStyle = css`
    word-break: break-all;
`;

interface TruncateComponentProps {
    content: ReactNode;
    className?: string;
    dataTestId?: string;
}

export const TruncateComponent: FC<TruncateComponentProps> = ({ content, className, dataTestId }) => {
    const spanRef = useRef<HTMLSpanElement | null>(null);
    const [truncated, setTruncated] = useState(false);

    useEffect(() => {
        if (spanRef.current && isTruncated(spanRef.current)) {
            setTruncated(true);
        }
    }, [setTruncated]);

    if (!truncated) {
        return (
            <span ref={spanRef} className={cx(truncate, className)} data-testid={dataTestId ?? "truncate-text"}>
                {content}
            </span>
        );
    }

    return (
        <Tooltip content={content} className={tooltipStyle}>
            <span ref={spanRef} className={cx(truncate, className)} data-testid={dataTestId ?? "truncate-text"}>
                {content}
            </span>
        </Tooltip>
    );
};
